import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import LOOKUP_TYPES from '../../common/constants/SuccessPlanConstants';
import { request } from '../../common/util/RestClient';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';
import envConfig from '../../config';
import {
  fetchMilestoneStatusLookups,
  fetchMilestones,
  fetchMilestoneById,
  createMilestone,
  editMilestone,
  completeMilestone,
  fetchMilestoneStatus,
  markMilestoneInprogress,
  archiveMilestone,
} from '../routines/successPlanRoutines';

const SUCCESS_PLAN_BASE_URL = `${envConfig.APIG_URL}success-plan`;

function* fetchMilestonesSaga({ payload }) {
  try {
    const { successPlanId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone`;
    const response = yield call(request, url);
    yield put(fetchMilestones.success(response.data));
  } catch (error) {
    yield put(fetchMilestones.failure({ error }));
  } finally {
    yield put(fetchMilestones.fulfill());
  }
}
function* fetchMilestoneByIdSaga({ payload }) {
  try {
    const { successPlanId, milestoneId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}`;
    const response = yield call(request, url);
    yield put(fetchMilestoneById.success(response.data));
  } catch (error) {
    yield put(fetchMilestoneById.failure({ error }));
  } finally {
    yield put(fetchMilestoneById.fulfill());
  }
}

function* fetchMilestoneStatusSaga({ payload }) {
  try {
    const { successPlanId, milestoneId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}/status`;
    const response = yield call(request, url);
    yield put(fetchMilestoneStatus.success(response.data));
  } catch (error) {
    yield put(fetchMilestoneStatus.failure({ error }));
  } finally {
    yield put(fetchMilestoneStatus.fulfill());
  }
}

function* completeMilestoneSaga({ payload }) {
  try {
    const { successPlanId, milestoneId, completeAll } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}/complete?complete_all=${!!completeAll}`;
    const response = yield call(request, url, { method: 'PUT', payload: {} });

    yield put(completeMilestone.success(response.data));
    yield put(
      fetchMilestones.trigger({
        successPlanId,
      })
    );
    yield put(
      fetchMilestoneById.trigger({
        successPlanId,
        milestoneId,
      })
    );
  } catch (error) {
    yield put(completeMilestone.failure({ error }));
  } finally {
    yield put(completeMilestone.fulfill());
  }
}

function* markMilestoneInprogressSaga({ payload }) {
  try {
    const { successPlanId, milestoneId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}/uncomplete`;
    const response = yield call(request, url, { method: 'PUT', payload: {} });

    yield put(markMilestoneInprogress.success(response.data));
    yield put(
      fetchMilestones.trigger({
        successPlanId,
      })
    );
    yield put(
      fetchMilestoneById.trigger({
        successPlanId,
        milestoneId,
      })
    );
  } catch (error) {
    yield put(markMilestoneInprogress.failure({ error }));
  } finally {
    yield put(markMilestoneInprogress.fulfill());
  }
}
function* createMilestoneSaga({ payload }) {
  try {
    const { successPlanId, milestone, history, entity, level } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone`;
    const {
      name,
      description,
      startDate,
      dueDate,
      ownerId,
      collaborators,
      statusId,
      taskIds,
    } = milestone;

    const config = {
      method: 'POST',
      payload: {
        name,
        description,
        dueDate: dueDate.format('YYYY-MM-DD'),
        startDate: startDate.format('YYYY-MM-DD'),
        ownerId,
        collaborators,
        statusId,
        taskIds,
      },
    };
    const response = yield call(request, url, config);
    const milestoneId = response?.data?.milestoneId;
    const entityId = entity?.organizationId || entity?.accountId;
    history.push(
      `/app/${level.toLowerCase()}/${entityId}/success-plans/${successPlanId}?milestone=${milestoneId}`
    );
    yield put(
      createMilestone.success({
        ...response.data,
        successMessage: SUCCESS_MESSAGES.ADD_SUCCESS_PLAN_MILESTONE,
      })
    );
    yield put(
      fetchMilestones.trigger({
        successPlanId,
      })
    );
  } catch (error) {
    yield put(createMilestone.failure({ error }));
  } finally {
    yield put(createMilestone.fulfill());
  }
}
function* editMilestoneSaga({ payload }) {
  try {
    const { milestone, successPlanId, milestoneId } = payload;
    const {
      name,
      description,
      startDate,
      dueDate,
      ownerId,
      collaborators,
      statusId,
      taskIds,
    } = milestone;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}`;
    const config = {
      method: 'PUT',
      payload: {
        name,
        description,
        dueDate: dueDate.format('YYYY-MM-DD'),
        startDate: startDate.format('YYYY-MM-DD'),
        ownerId,
        statusId,
        collaborators,
        taskIds,
      },
    };
    const response = yield call(request, url, config);
    yield put(editMilestone.success(response.data));
    yield put(
      fetchMilestoneById.trigger({
        successPlanId,
        milestoneId,
      })
    );
  } catch (error) {
    yield put(editMilestone.failure({ error }));
  } finally {
    yield put(editMilestone.fulfill());
  }
}

function* fetchMilestoneStatusLookupsSaga() {
  try {
    const url = `${SUCCESS_PLAN_BASE_URL}/lookup?type=${LOOKUP_TYPES.MILESTONE_STATUS}`;
    const response = yield call(request, url);
    yield put(fetchMilestoneStatusLookups.success(response.data));
  } catch (error) {
    yield put(fetchMilestoneStatusLookups.failure({ error }));
  } finally {
    yield put(fetchMilestoneStatusLookups.fulfill());
  }
}

function* archiveMilestoneSaga({ payload }) {
  try {
    const { successPlanId, milestoneId } = payload;
    const url = `${SUCCESS_PLAN_BASE_URL}/success-plan/${successPlanId}/milestone/${milestoneId}/archive`;
    const response = yield call(request, url, { method: 'PATCH', payload: {} });

    yield put(archiveMilestone.success(response.data));
    yield put(fetchMilestones.trigger({ successPlanId }));
    yield put(
      fetchMilestoneById.trigger({
        successPlanId,
        milestoneId,
      })
    );
  } catch (error) {
    yield put(archiveMilestone.failure({ error }));
  } finally {
    yield put(archiveMilestone.fulfill());
  }
}

export default function* root() {
  yield all([
    takeLatest(
      fetchMilestoneStatusLookups.TRIGGER,
      fetchMilestoneStatusLookupsSaga
    ),
    takeLatest(fetchMilestones.TRIGGER, fetchMilestonesSaga),
    takeLatest(fetchMilestoneById.TRIGGER, fetchMilestoneByIdSaga),
    takeEvery(createMilestone.TRIGGER, createMilestoneSaga),
    takeEvery(editMilestone.TRIGGER, editMilestoneSaga),
    takeLatest(fetchMilestoneStatus.TRIGGER, fetchMilestoneStatusSaga),
    takeLatest(completeMilestone.TRIGGER, completeMilestoneSaga),
    takeLatest(markMilestoneInprogress.TRIGGER, markMilestoneInprogressSaga),
    takeLatest(archiveMilestone.TRIGGER, archiveMilestoneSaga),
  ]);
}
